import { Component } from '@angular/core';
import { CustomerEnum } from '../../../../../../utils/src/lib/enums/customer.enum';

@Component({
  selector: 'ebw-monorepo-otdr',
  templateUrl: './otdr.component.html',
  styleUrls: ['./otdr.component.scss']
})
export class OtdrComponent {
  customerEnum = CustomerEnum;
  constructor() {}
}
